import { createActionConst } from '../../../../utils/action.utils';

const NODE_NAMESPACE = 'NODES';

export const CREATE_NODE = createActionConst(NODE_NAMESPACE, 'CREATE_NODE');
export const UPDATE_NODE = createActionConst(NODE_NAMESPACE, 'UPDATE_NODE');
export const UPDATE_NODES_POSITIONS = createActionConst(NODE_NAMESPACE, 'UPDATE_NODES_POSITIONS');
export const DELETE_NODE = createActionConst(NODE_NAMESPACE, 'DELETE_NODE');
